module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFlag) ? _c('div', {
    staticClass: "download-banner-box",
    class: _vm.positionCls
  }, [_c('div', {
    staticClass: "download-banner"
  }, [_c('div', {
    staticClass: "fix-l",
    on: {
      "click": _vm.closeBannerAction
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "fluid-wrap"
  }, [_c('div', {
    staticClass: "fluid-box"
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logoImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('p', {
    staticClass: "text title"
  }, [_vm._v(_vm._s(_vm.downloadData.title))]), _vm._v(" "), _c('p', {
    staticClass: "text content"
  }, [_vm._v(_vm._s(_vm.downloadData.describe))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fix-r"
  }, [_c('open-app', {
    staticClass: "download-btn",
    attrs: {
      "text": _vm.text,
      "link": _vm.link,
      "pageType": _vm.pageType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "download-prompt"
  }, [_vm._v("开发者: Shanghai Yi-pai E-commerce Co.,Ltd   版本号: 5.2.2   "), _c('span', {
    staticClass: "prompt-link",
    on: {
      "click": _vm.permissionAction
    }
  }, [_vm._v("用户权限")]), _vm._v("   "), _c('span', {
    staticClass: "prompt-link",
    on: {
      "click": _vm.ruleAction
    }
  }, [_vm._v("隐私条款")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close-box"
  }, [_c('div', {
    staticClass: "close"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5ed7f1c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/download-banner/index.vue
// module id = 273
// module chunks = 1 2 3 4 5 7 8 13 19